import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Color-coded badge for a suspicion score. The tier breakpoints mirror
 * ChatGPT's original plan (0-2 legit, 3-5 suspicious, 6-8 very sus, 9+ likely
 * cheating) so reviewers get an at-a-glance hint without reading each flag.
 *
 * @param {object} props
 * @param {number} props.score - Normalised sus-score (0-10).
 */
export default function SusScoreBadge({ score }) {
  const { t } = useTranslation();
  const value = typeof score === 'number' ? score : 0;
  let tier = 'clean';
  if (value >= 9) tier = 'cheat';
  else if (value >= 6) tier = 'sus';
  else if (value >= 3) tier = 'watch';

  return (
    <span className={`sus-badge tier-${tier}`} title={t('overwatch.suspicionScoreTitle', { score: value.toFixed(1) })}>
      {value.toFixed(1)}
    </span>
  );
}
